module.exports = __webpack_public_path__ + "f486260f7324aaa79b2c68f5127bf365.pdf";